





































































































import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { eventBus } from '@/main';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import Paging from '@/shared/components/Paging.vue';
import { WalletHistory } from '@/models/wallet-history';
import creditServices from '@/services/credit-services';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

@Component({
    components: {
        Paging,
        Loading,
        Datepicker
    }
})
export default class WalletHistories extends Vue {
    private pageSettings = {
      rowPerPage: 10,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private listWalletlHistories: WalletHistory[] = [];
    private isLoading = false;
    private startDate: Date | null = null;
    private endDate: Date | null = null;
    private searchContent = '';
    private searchOrderId = '';

    private async created() {
        eventBus.$on(APP_CONFIG.eventBusAction.reloadWithdrawalHistories, () => {
            this.pageSettings.pageIndex = 1;
            this.loadHistories();
        });
        this.loadHistories();
    }

    private onSearch() {
        this.pageSettings.pageIndex = 1;
        this.loadHistories();
    }

    private onClearSearch() {
        this.startDate = null;
        this.endDate = null;
        this.searchContent = '';
        this.searchOrderId = '';
        this.pageSettings.pageIndex = 1;
        this.loadHistories();
    }

    private async loadHistories() {
        this.isLoading = true;
        const filters: any[] = [];
        if (this.startDate) {
            filters.push({ field: 'CreateDate', operator: 'gte', value: moment(this.startDate).format('YYYY-MM-DD 00:00:00') });
        }
        if (this.endDate) {
            filters.push({ field: 'CreateDate', operator: 'lte', value: moment(this.endDate).format('YYYY-MM-DD 23:59:59') });
        }
        if (this.searchContent) {
            filters.push({ field: 'HContent', operator: 'contains', value: this.searchContent });
        }
        if (this.searchOrderId) {
            filters.push({ field: 'MainOrderId', operator: 'eq', value: Number(this.searchOrderId) });
        }

        const result = await creditServices.walletHistories(
            this.pageSettings.pageIndex,
            this.pageSettings.rowPerPage,
            filters
        );
        if (result && result.status === 200) {
            const rawList = Array.isArray(result.data.data) ? result.data.data : (result.data.data && result.data.data.list ? result.data.data.list : []);
            this.pageSettings.total = result.data.total !== undefined ? result.data.total : ((result.data.data && result.data.data.total) || 0);
            this.listWalletlHistories = rawList.map((item: any) => {
                const history: WalletHistory = {
                    amount: item.Amount,
                    createBy: item.CreatedBy || item.CreateBy,
                    createDate: item.CreatedDate || item.CreateDate,
                    hContent: item.HContent,
                    id: item.ID,
                    moneyLeft: item.MoneyLeft,
                    type: item.Type,
                    tradeType: item.TradeType,
                    tradeTypeDetail: (DATA.walletTradeType || []).find((x: any) => x.value === item.TradeType) || { name: 'Giao dịch', color: '#64748b' },
                    uId: item.UID,
                    userName: item.Username || item.UserName,
                    mainOrderId: item.MainOrderID || item.MainOrderId,
                    userRecharge: item.UserRecharge,
                    rechargeId: item.RechargeID || item.RechargeId,
                    orderType: item.OrderType
                };
                return history;
            });
        }
        this.isLoading = false;
    }

    private onChangePage(page: number) {
        this.pageSettings.pageIndex = page;
        this.loadHistories();
    }
}
